// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  "version": "1.0.0",
  "hash": "c057f94d47935193ffcb95ce286dda501044fcf1"
};
/* tslint:enable */
